<template>
  <div>
    <!--S 右侧区域-->
    <router-view></router-view>
    <!--E 右侧区域-->
  </div>
</template>
<script>
export default {
  name: 'Templent_Goods',
  data () {
    return {

    }
  },
  filters: {

  },
  components: {

  },
  methods: {

  },
  created() {
    
  },
  mounted () {

  },
  computed: {}
}
</script>

<style scoped>
/*注意：每个模板的动画样式必须保持一致*/
</style>



// WEBPACK FOOTER //
// src/views/GoodsFolder/Templent_Goods.vue